/**
 * Trace console : quelle API est appelée pour les refs bon de réception / bon de sortie.
 * Filtrer la console sur : BR référence
 */
export type BonReceptionLinkedApiLogEntry = {
  /** Nom lisible, ex. « Bon réception linked-workflow (batch) » */
  api: string;
  method: 'GET' | 'POST' | 'PUT';
  url: string;
  request?: unknown;
  result?: unknown;
  error?: unknown;
  brId?: number;
};

export function logBonReceptionLinkedApi(entry: BonReceptionLinkedApiLogEntry): void {
  if (typeof console === 'undefined') {
    return;
  }
  const ok = entry.error == null;
  const title = ok
    ? `[BR référence] ✓ ${entry.api}`
    : `[BR référence] ✗ ${entry.api}`;
  try {
    console.groupCollapsed(title);
  } catch {
    console.warn(title);
  }
  if (entry.brId != null) {
    console.log('bon_reception_id (liste):', entry.brId);
  }
  console.log('Méthode + URL:', entry.method, entry.url);
  if (entry.request !== undefined) {
    console.log('Requête (body / params):', entry.request);
  }
  if (ok) {
    console.log('Résultat API:', entry.result);
  } else {
    console.error('Erreur API:', entry.error);
  }
  try {
    console.groupEnd();
  } catch {
    /* ignore */
  }
}

/** Pourquoi la colonne affiche « — » */
export function logBonReceptionLinkedDisplayDash(
  brId: number,
  reason: string,
  detail?: unknown
): void {
  console.warn(`[BR référence] Affichage « — » pour BR #${brId} → ${reason}`, detail ?? '');
}
